




















import { defineComponent, useAsync } from '@nuxtjs/composition-api'

// Component
import SupportTile from './SupportTile.vue'
import TechnicalSupportIconSVG from '@/assets/images/support/technical-support.svg?inline'
import OrderSupportIconSVG from '@/assets/images/support/order-support.svg?inline'
import SalesSupportIconSVG from '@/assets/images/support/sales-support.svg?inline'

// Store
import { useCMSDynadminStore } from '@/store/cms'

export default defineComponent({
  name: 'SupportContactTiles',

  components: {
    SupportTile,
    TechnicalSupportIconSVG,
    OrderSupportIconSVG,
    SalesSupportIconSVG,
  },

  setup() {
    const CMSDynadminStore = useCMSDynadminStore()

    // Local config
    const supportTiles = [
      {
        slug: 'technical-support',
        title: 'Technical Support',
        icon: 'TechnicalSupportIconSVG',
        form: '/learn-and-support/support-information/technical-support',
      },
      {
        slug: 'customer-support',
        title: 'Customer Support',
        icon: 'OrderSupportIconSVG',
        form: '/learn-and-support/support-information/customer-support',
      },
      {
        slug: 'sales-support',
        title: 'Contact Sales',
        icon: 'SalesSupportIconSVG',
        form: '/learn-and-support/support-information/sales-department',
      },
    ]

    // Fetch regional settings
    useAsync(
      () => CMSDynadminStore.fetchRegionalSettings(['technical-support', 'customer-support', 'sales-support']),
      'fetchRegionalSettings'
    )

    return {
      supportTiles,
      CMSDynadminStore,
    }
  },
})
